import * as classnames from 'classnames'
import {List, ListItem} from '@luminopia/react-toolbox/lib/list'
import {ILuminopiaLogoVerticalTheme, LuminopiaLogoVertical} from 'core/components/LuminopiaLogo'
import {routeProps} from 'core/utils/react-router-helpers'
import * as React from 'react'
import {RouteComponentProps} from 'react-router'
import * as classNames from './PasswordChange.css'

interface ITheme extends ILuminopiaLogoVerticalTheme {
  logoContainer?: string
  formContainer?: string
}
interface IProps {
  /** return value is rendered in the form container */
  renderForm?: (values: any) => any
  values?: any
  className?: string
  theme?: ITheme
}


/**
 * Standard interface with a Luminopia logo as the header.
 */
class PasswordChange extends React.Component<IProps, {}> {
  public render() {
    const { renderForm, theme = {} } = this.props

    const logoTheme = {
      graphic: classnames(theme.graphic, classNames.graphic),
      lettering: classnames(theme.lettering, classNames.lettering),
    }


    return (
      <div className={this.props.className}>
        <div className={theme.formContainer}>
        {renderForm && renderForm(this.props.values)}
        </div>
      </div>
    )
  }
}

export default PasswordChange



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/passwordChange/PasswordChange.tsx